import styled from 'styled-components';

import Modal from 'components/modal';
import Table from 'components/table';
import { device } from 'helpers/screenSizes';
import handSymbol from 'styles/assets/list.png';
import { PageHeader } from 'UIKit';
import './withdrawal.scss';

export const WithdrawalWrapper = styled.div`
  color: ${props => props.theme.primaryText};
  font-family: var(--fontRegular) !important;
  .balance-section-for-bar-code {
    padding-right: 5% !important;
    padding-left: 5% !important;
  }
  .desktop-section {
    width: 100%;
    flex: 1;
  }

  .withdrawal-container {
    width: 100%;
  }

  .withdrawal-limit {
    font-family: var(--fontRegular);
    font-size: 14px;
    color: ${props => props.theme.secondaryText};
    margin-bottom: 35px;
    .current-limit {
      color: ${props => props.theme.primaryText};
      font-family: var(--fontRegular);
    }
    .get-verified-link {
      color: ${props => props.theme.primaryTheme};
      margin-left: 18px;
      cursor: pointer;
    }
    svg {
      margin-right: 8px;
      margin-top: 0;
    }
  }

  .withdrawal-top {
    &.disable {
      .Dropdown-control {
        cursor: none;
        pointer-events: none;
      }
    }
    .forfeit-link {
      display: flex;
      justify-content: flex-end;
      color: ${props => props.theme.primaryTheme};
      font-size: 12.1px;
      font-family: var(--fontRegular);
      cursor: pointer;
      position: relative;
      left: 10px;
      // top: 2px;
      svg {
        position: relative;
        top: 2px;
      }
    }

    .label-text-wrapper {
      margin-bottom: 0;
    }

    .hr {
      height: 1px;
      width: 100%;
      margin: 10px 0px 10px 0px;
      opacity: 0.6;
      border: 0.8px solid ${props => props.theme.separator};
    }

    .networks-container {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 20px;
    }
    .network-checkbox {
      color: ${props => props.theme.primaryText};
      background: ${props => props.theme.secondaryBackground};
      border-radius: 2px;
      height: 50px;
      width: auto;
      padding-right: 10px;
      display: flex;
      font-family: var(--fontRegular);
      font-size: 12.1px;
      cursor: pointer;
      &.active {
        border: 1px solid ${props => props.theme.primaryTheme};
      }
      .network {
        font-family: var(--fontRegular);
        font-size: 12.1px;
        color: ${props => props.theme.primaryText};
        .withdrawal-fees-label {
          font-size: 10px;
          color: ${props => props.theme.secondaryText};
        }
        .converted-fees {
          margin-left: 10px;
          color: ${props => props.theme.secondaryText};
          font-family: var(--fontRegular);
        }
      }
    }
  }
  .currency {
    position: absolute;
    font-size: 14px;
    padding-left: 8px;
    border-left: 1px solid ${props => props.theme.primaryText};
    top: 36px;
    right: 18px;
    font-size: 12.1px;
    color: ${props => props.theme.secondaryText};
  }
  .input-label {
    font-family: var(--fontRegular);
    font-size: 12.1px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: 0.6px;
    color: ${props => props.theme.secondaryText};
    margin-bottom: 7px;
  }

  .max-withdrawable-button {
    position: absolute;
    top: 34px;
    left: 10px;
    font-family: var(--fontRegular);
    font-size: 12.1px;
    color: ${props => props.theme.primaryTheme};
    border-radius: 4px;
    padding: 5px 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .input-box {
    height: 44px;
    padding: 11px 18px;
    text-align: left;
    font-family: var(--fontRegular);
    background-color: var(--main-bg-primary);
    border: 1px solid var(--main-bg-secondary);
    font-size: 12px;

    &.max-input {
      padding: 11px 18px 11px 70px;
    }

    @media ${device.up.md} {
      font-size: 14px;
    }

    &:focus {
      border: 1px solid var(--brand-bg-primary);
    }
  }
  .input-section {
    margin-bottom: 25px;
    position: relative;
    width: 100%;
    &.network-section {
      margin-top: -4px;
    }
    &.memo {
      margin-top: 15px;
    }
    .input-area {
      display: flex;
      align-items: center;
      background-color: var(--inputBackground);
      border-radius: var(--inputBorderRadius);
      font-family: var(--fontRegular);

      .address-label {
        height: 25px;
        font-size: 14px;
        font-family: var(--fontRegular);
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: 0.6px;
        color: ${props => props.theme.primaryText};
        margin-left: 10px;
        border: 1px solid ${props => props.theme.separator};
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 3px 7px;
        max-width: 50px;
        display: inline-block;
        text-overflow: ellipsis;
        overflow: hidden;
        @media ${device.down.md} {
          margin-top: 0px;
        }
      }

      .input-box {
        font-size: 14px;
        color: ${props => props.theme.secondaryText};
        font-family: var(--fontRegular);
        text-align: left;
        width: 100%;
        text-overflow: ellipsis;
        position: relative;
        top: 0;
        padding-right: 80px;
      }
    }
    & > input {
      border-radius: var(--inputBorderRadius);
      background-color: var(--inputBackground);
      padding-right: 80px;
    }
  }
  .max-withdrawable-area {
    display: flex;
    justify-content: space-between;
    height: 100%;
    flex-direction: column;
    .forfeit-link {
      display: flex;
      justify-content: flex-end;
      color: ${props => props.theme.primaryTheme};
      font-size: 12.1px;
      font-family: var(--fontRegular);
      cursor: pointer;
      position: relative;
      left: 10px;
      // top: 2px;
      svg {
        position: relative;
        top: 2px;
      }
    }
    &.without-forfeit {
      .amount {
        color: ${props => props.theme.primaryTheme};
        text-decoration-line: underline;
      }
    }
    &.after-forfeit {
      .amount {
        text-align: right;
        &:hover {
          text-decoration: none;
          color: ${props => props.theme.primaryText};
          cursor: default;
        }
      }
      .amount-container {
        display: flex;
        justify-content: space-between;
        .forfeit-link svg {
          top: 1px;
        }
      }
      .forfeit-link {
        position: relative;
        left: 4px;
        font-size: 12.1px;
        align-items: center;
        display: flex;
      }
    }

    .hr {
      margin: 10px 0px 6px 0px;
    }

    .max-withdrawable-label {
      font-size: 12.1px;
      color: ${props => props.theme.secondaryText};
      font-family: var(--fontRegular);
      display: flex;
      margin-bottom: 4px;
    }

    .amount {
      font-family: var(--fontRegular);
      font-size: 12.1px;
      color: ${props => props.theme.primaryText};
      cursor: pointer;

      &:hover {
        text-decoration: underline;
        color: ${props => props.theme.primaryTheme};
      }

      @media ${device.down.md} {
        text-decoration: underline;
        color: ${props => props.theme.primaryTheme};
      }
    }
  }
  .completed-withdrawal-history-section {
    text-align: center;
    height: 50px;
    margin-bottom: 27px;
    width: 100%;

    .back-to-pending {
      border-bottom: 1px solid ${props => props.theme.separator};
      width: 100vw;
      display: flex;
      align-items: center;
      justify-items: center;
      justify-content: center;
      margin-top: -15px;
    }
  }

  .loader {
    height: 300px;
    @media ${device.down.md} {
      position: relative;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .loader-dots {
        position: absolute;
      }
    }
  }

  .back-to-withdrawal {
    height: 38px;
    width: 100vw;
    padding-top: 8px;
    background-color: ${props => props.theme.secondaryBackground};
    margin-top: -5%;
    display: inline-block;
    text-align: center;
    position: relative;

    .back-to-pending {
      padding: 9px;
      padding-top: 8px;
      text-align: center;
      height: 18px;
      font-family: var(--fontRegular);
      font-size: 12.1px;
      font-style: normal;
      line-height: 1.5;
      color: ${props => props.theme.primaryTheme};
      display: flex;
      justify-content: center;
      align-items: center;

      svg {
        color: ${props => props.theme.primaryTheme};
        margin-top: 3px;
      }

      span {
        padding-left: 5px;
      }
    }
  }

  .withdrawal-form {
    flex-basis: 50%;
    border-left: solid 1px ${props => props.theme.separator};
    display: flex;
    align-items: center;
    padding-left: 10%;
    padding-right: 2%;

    @media ${device.down.md} {
      flex-basis: 100%;
      border: none;
      border-top: solid 1px ${props => props.theme.separator};
      padding: unset;
      padding-top: 20px;
      padding-left: 3px;
    }
  }

  .kyc-row {
    border: solid 0.6px ${props => props.theme.separator};
    background-color: ${props => props.theme.secondaryBackground};
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px !important;
    height: 42px;
    .text {
      font-size: 12.1px;
      font-family: var(--fontRegular);
      line-height: 1.67;
      letter-spacing: 0.6px;
      color: ${props => props.theme.secondaryText};
    }
    a {
      font-size: 12.1px;
      font-family: var(--fontRegular);
      line-height: 1.67;
      color: ${props => props.theme.primaryTheme};
      cursor: pointer;
      &:hover {
        text-decoration: none;
      }
    }
    @media ${device.down.md} {
      padding: 0 7px 0 12px !important;
      a svg {
        margin-top: -2px;
      }
    }
  }

  .notice {
    margin-top: 0px;
    border: solid 0.6px ${props => props.theme.separator};
    background-color: #131c26;
    padding: 15px !important;
    line-height: 2 !important;
    text-align: center;
    color: ${props => props.theme.secondaryText};
    font-family: var(--fontRegular);
    font-size: 14px;
    text-align: center;
    color: ${props => props.theme.secondaryText};
    justify-content: center;

    b {
      font-size: 14px;
      font-family: var(--fontRegular);
      color: white;
    }

    @media ${device.down.md} {
      font-size: 12.1px;
      display: flex;
      flex-direction: column;
    }
  }

  //  .form-area{
  //    margin-bottom : 42px;
  //    width:100%;
  //    @media ${device.down.sm}{
  //     padding-left: 3px;
  //   }

  input.form-control {
    text-align: right;
    background-color: ${props => props.theme.secondaryBackground};
    font-size: 14px;
    line-height: 1.43;
    height: 32px;
    padding: 6px;

    @media ${device.up.md} {
      padding-right: 8px;
    }
    @media ${device.up.lg} {
      padding-right: 12px;
    }
  }

  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .sub-header-text {
    font-family: 'inherit';
  }

  label {
    color: ${props => props.theme.secondaryText};
  }

  .form-control {
    color: ${props => props.theme.primaryText};
    background-color: transparent;
    border: none;
  }

  .note {
    margin-top: 40px;
    padding-top: 20px;
    font-size: 14px;
    line-height: 1.75;
    background-color: ${props => props.theme.secondaryBackground};

    @media ${device.up.lg} {
      width: 550px;
    }
  }

  .error {
    font-size: 11px;
    color: ${props => props.theme.negative};
    width: 100%;
  }

  .outline {
    border: 1px solid ${props => props.theme.negative};
  }

  .info-icon {
    font-size: 13px;
    color: ${props => props.theme.negative};
  }

  .submit-btn {
    &.get-verified-btn {
      @media ${device.down.sm} {
        width: 150px;
        padding: 0 !important;
        height: 42px !important;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .btn {
        position: relative;
        border: none;
        font-size: 14px;
        span {
          display: inline-block;
          position: absolute;
          right: 0;
          top: 0;
          height: 100%;
          padding: 10px 15px;
          background-color: ${props => props.theme.primaryButtonHover};
          .popover-base {
            width: 14px;
            height: 14px;
          }
          @media ${device.down.sm} {
            padding: 10px 13px 10px 15px;
            background-color: unset;
          }
        }
      }
    }
    .btn {
      color: var(--primaryCtaText);
      background-color: ${props => props.theme.primaryTheme} !important;
      margin: 0px;
      border-radius: 0;
      font-size: 14px;
      line-height: 24px;
      font-family: var(--fontRegular);
      padding: 0;
      height: 42px !important;
      letter-spacing: 0.3px;
      &:hover {
        background-color: ${props => props.theme.primaryButtonHover} !important;
        color: var(--primaryCtaTextHover);
      }
      &.enable-btn {
        &:hover {
          background-color: #0ca2cf !important;
        }
      }

      @media ${device.down.sm} {
        font-size: 14px;
        line-height: 1.43;
        // width: 164px;
        // height: 40px;
        // position: fixed;
        /* bottom: 40px; */
      }
    }
    @media ${device.down.sm} {
      display: flex;
      justify-content: center;
    }
  }

  .right-column {
    text-align: right;
  }

  .only-text {
    font-size: 14px;
    margin-left: 4px;
    @media ${device.down.md} {
      font-size: 12.1px;

      &.withdraw-amount {
        margin-left: 0;
        width: 100%;
      }
    }
  }

  .icons {
    padding-left: 4px;
  }

  .icons g {
    fill: ${props => props.theme.primaryText} !important;
  }

  .info-icon {
    margin-top: -5px;
  }

  .icon {
    margin: 10px 16px 10px 16px;
  }

  .form-label {
    color: ${props => props.theme.lightergrey3};
    font-size: 10px;
    line-height: 1.5;
  }

  .curencytype {
    opacity: 0.5;
    font-size: 12.1px;
    line-height: 1.5;
    text-align: right;
    color: ${props => props.theme.primaryText};
    margin: auto 0;
    padding-left: 10px;
    padding-right: 0px;

    @media screen and (${device.up.md}) {
      padding-right: 0px;
    }
    @media screen and (${device.up.lg}) {
      padding-right: 0px;
    }
  }

  .input-currencytype {
    opacity: 0.5;
    font-size: 12.1px;
    line-height: 1.5;
    text-align: right;
    color: ${props => props.theme.primaryText};
    margin: auto 0;
  }
  .max-withdrawal-amount {
    padding-left: 15px;
  }
  .max-withdraw-label-mobile {
    padding-left: 5px !important;
  }
  .withdrawal-amount {
    font-size: 14px;
    font-family: var(--fontRegular);
    line-height: 1.43;
    text-align: right;
    margin-right: 0;
    @media ${device.down.md} {
      font-size: 12.1px;
      &.withdrawal-fee {
        font-size: 10px;
      }
    }

    .value {
      cursor: pointer;
    }
  }

  .withdrawal-fee {
    font-size: 12.1px;
    color: ${props => props.theme.primaryText};
    del {
      color: ${props => props.theme.primaryText};
      margin-left: 10px;
    }
  }

  .quote {
    margin-top: 10px;
  }

  .important-text {
    font-size: 16px;
    font-family: var(--fontRegular);
    line-height: 1.5;
    color: ${props => props.theme.primaryText};
    margin: auto 0;
  }

  .withdrawal-label-text {
    font-family: var(--fontRegular);
    font-size: 14px;
    color: ${props => props.theme.primaryText};
  }

  .available-balance {
    font-size: 10px;
    font-family: var(--fontRegular);
    line-height: 1.43;
    color: ${props => props.theme.secondaryText};
    text-align: right;

    @media ${device.down.sm} {
      font-size: 14px;
      line-height: 1.5;
      margin-right: 0px;
      padding-top: 2px;
      margin-top: 9px;
    }
  }

  .available-price {
    font-size: 16px;
    font-family: var(--fontRegular);
    line-height: 1.44;
    text-align: left;
    color: ${props => props.theme.primaryText};

    @media ${device.down.sm} {
      padding-right: 0;
      font-size: 14px;
      line-height: 1.43;
    }
  }

  .requirement-section {
    padding: 16px;
    opacity: 0.6;
    font-size: 14px;
    font-family: var(--fontRegular);
    line-height: 1.43;
    color: ${props => props.theme.primaryText};

    label {
      padding: 5px 0;
    }

    @media ${device.up.lg} {
      margin-left: 50px;
      width: 478px;
      padding: 5px;
    }
    ul {
      list-style-type: none;

      li {
        padding: 5px 0;
      }
    }
    ul > li::before {
      position: absolute;
      content: '';
      background: url(${handSymbol}) no-repeat center / 100% auto;
      width: 20px;
      height: 19px;
      margin-left: -25px;
      margin-top: 4px;
    }
  }

  .btc {
    position: absolute;
    top: 5px;
    right: 6px;
    @media ${device.up.md} {
      top: 8px;
      right: 8px;
    }
    @media ${device.down.md} {
      top: 5px;
      right: 19px;
    }
    @media screen and (${device.up.lg}) {
      right: 12px;
    }
  }

  .middleline {
    width: 100%;
    height: 1px;
    opacity: 0.1;
    background-color: ${props => props.theme.primaryText};
    margin: 24px 0;
  }

  .available-section {
    padding-right: 0px;
    @media ${device.down.lg} {
      padding-right: 35px;
    }
    @media ${device.down.sm} {
      padding-right: 5px;
    }
  }

  .amountInput {
    padding-right: 45px !important;

    @media screen and (${device.up.md}) {
      padding-right: 45 px !important;
    }
    @media screen and (${device.up.lg}) {
      padding-right: 45px !important;
    }
  }

  .icon-color {
    #Withdrawals {
      /* #Withdrawals-(DESKTOP) {
        fill: ${props => props.theme.primaryTextNegative};
      } */
    }
  }

  @media ${device.down.md} {
    .text-start {
      text-align: left;
    }
  }

  .balance-section {
    display: flex;
    width: 100%;
  }

  .information-box {
    width: calc(min(400px, 100%));
    color: ${props => props.theme.primaryText};
    background-color: ${props => props.theme.primaryBackground};
    border: solid 0.6px ${props => props.theme.separator};
    font-family: var(--fontRegular) !important;
    font-size: 14px;
    font-stretch: normal;
    font-style: normal;
    line-height: 40px;
    letter-spacing: 0.6px;
    margin-bottom: 10px;
    cursor: pointer;
    height: 42px;

    svg {
      margin: 2px 4px 6px 2px;
    }

    img {
      margin: 3px;
    }

    .info-utf8-icon {
      color: #0090bc;
      font-size: 14px;
    }

    &:hover {
      border: 0.8px solid ${props => props.theme.primaryTheme};
    }

    @media ${device.down.md} {
      font-size: 12.1px;
      margin-top: 7px;
    }
  }

  .forfeit-msg-div {
    .border-red {
      border-left: 1px solid ${props => props.theme.separator};
    }
  }

  .without-forfeiting-bonus {
    width: 100%;
    display: flex;
    height: 50px;
    background-color: #0a1520;
    align-self: end;
    padding: 5px 0px 5px 0px;
    border-left: 1px solid ${props => props.theme.separator};
    box-sizing: content-box;
    justify-content: space-between;

    .msg {
      font-family: var(--fontRegular);
      font-size: 11px;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.64;
      letter-spacing: 0.6px;
      color: ${props => props.theme.primaryText};
      margin: auto;
      width: 51%;
      text-align: left;
    }

    .max-withdrawable-msg {
      font-family: var(--fontRegular);
      font-size: 11px;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.64;
      letter-spacing: 0.6px;
      color: ${props => props.theme.primaryText};
      text-align: left;
      margin: 15px 0px 0px 10px;
    }

    .value {
      font-family: var(--fontRegular);
      font-size: 12.1px;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: 0.6px;
      color: ${props => props.theme.primaryText};
      margin: 15px 10px 0px 0px;
      width: 40%;
      cursor: pointer;
      text-align: right;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .forfeit-msg {
    display: flex;
    justify-content: center;

    .bonus-forfeit-msg {
      font-family: var(--fontRegular);
      font-size: 12.1px;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: 0.6px;
      color: ${props => props.theme.primaryText};
      margin-top: auto;
    }
  }
`;

export const CoinDropDownModal = styled(Modal)`
  width: 100% !important;
  height: auto !important;
  bottom: 0 !important;
  left: 0 !important;
  top: unset !important;
  padding: 0 !important;
  position: fixed;
  background: ${props => props.theme.primaryBackground} !important;
  .modal-header {
    font-family: var(--fontRegular);
    font-size: 14px;
    color: ${props => props.theme.secondaryText};
    height: 45px;
    border-bottom: 0.8px solid ${props => props.theme.separator};
    display: flex;
    align-items: center;
    justify-content: center;
    .close-icon {
      position: absolute;
      right: 25px;
    }
  }
  .modal-body {
    display: flex;
    flex-direction: column;
    .coin-symbol {
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: var(--fontRegular);
      font-size: 14px;
      color: ${props => props.theme.primaryText};
      svg {
        margin: -2px 10px 0 0;
      }
      &:not(:last-of-type) {
        border-bottom: 0.8px solid ${props => props.theme.separator};
      }
      &.active {
        color: ${props => props.theme.primaryTheme};
      }
    }
  }
`;

export const AddressSection = styled.div`
  font-size: 12.1px;
  font-family: var(--fontRegular);
  line-height: 1.67;
  color: ${props => props.theme.secondaryText};
  padding-top: 6px;

  p {
    font-family: var(--fontRegular);
    font-size: 12.1px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: 0.6px;
    color: ${props => props.theme.secondaryText};

    .copySpan {
      &:active,
      &:hover {
        color: ${props => props.theme.primaryTheme} !important;
      }
    }
  }
`;

export const HeaderText = styled(PageHeader)`
  margin-bottom: 10px;

  @media ${device.down.md} {
    font-size: 14px;
    line-height: 1.43;
    margin-bottom: 13px;
  }
`;

export const BalanceSection = styled.div`
  @media ${device.down.md} {
    margin-top: 0px;
    padding-top: 0px;
  }

  @media ${device.up.md} {
    display: flex;
    display: -ms-flexbox;
    flex-direction: column;
    margin: 0;
  }

  .select-coin-label {
    font-size: 12.1px;
    margin-bottom: 7px;
    color: ${props => props.theme.secondaryText};
    font-family: var(--fontRegular);
    margin-top: 0px !important;
  }

  .dropdown-label {
    position: relative;
    overflow: hidden;
    // background-color: #212933;
    // border: 0px solid #212933;
    border-radius: var(--inputBorderRadius);
    box-sizing: border-box;
    color: ${props => props.theme.primaryText};
    border: 1px solid var(--inputBorderColor);
    background-color: var(--inputBackground);
    font-family: var(--fontRegular);
    font-size: 14px;
    cursor: pointer;
    outline: none;
    padding: 10px 18px;
    -webkit-transition: all 200ms ease;
    transition: all 200ms ease;
    .option svg {
      position: relative;
      top: 0;
      right: 0;
      margin: -2px 10px 0 0;
    }

    svg {
      position: absolute;
      right: 17px;
      top: 20px;
    }
  }

  .wallet-details-coin {
    display: flex;
    flex-direction: column;
  }

  .balance-bonus-section {
    display: flex;
    flex-direction: column;
    height: fit-content;
    margin-top: 26px;
    justify-content: space-between;

    @media ${device.down.md} {
      margin-top: 10px;
      &.balance-bonus {
        background: var(--main-bg-primary);
        padding: 10px 14px;
        height: 70px;
        display: flex;
        justify-content: center;
        .balances:first-child {
          margin-bottom: 10px;
        }
      }
    }

    .balances {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 10px;
      margin-bottom: 18px;

      @media ${device.down.md} {
        justify-content: flex-start;
        margin-bottom: 0px;
      }
    }

    .hr {
      height: 0.2px;
      opacity: 0.4;
      background-color: #273444;
      border: solid 0.6px rgba(61, 79, 106, 0.4) !important;
      margin: 15px 0 15px 0;
    }

    .available-balance {
      @media ${device.down.md} {
        font-size: 10px;
        padding: 0;
        margin-top: 0;
        position: relative;
      }
    }

    .balance-label {
      font-family: var(--fontRegular);
      font-size: 12.1px;
      color: ${props => props.theme.secondaryText};
    }

    .balanceAmount {
      .value {
        font-family: var(--fontRegular);
        font-size: 12.1px;
        color: ${props => props.theme.primaryText};
        text-align: right;
        white-space: nowrap;
      }

      @media ${device.down.md} {
        display: flex;
        align-items: center;
        gap: 4px;
      }
    }
  }

  .withdrawal-text {
    font-family: var(--fontRegular);
    display: flex;
    font-size: 14px;
    color: ${props => props.theme.secondaryText} !important;
  }

  @media ${device.down.md} {
    flex-basis: 100%;
    margin-bottom: 25px;
    padding-right: 0px;
  }
  .Dropdown-root {
    position: relative;
  }

  .Dropdown-control {
    height: 42px;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    color: ${props => props.theme.primaryText};
    font-family: var(--fontRegular);
    font-size: 14px;
    cursor: pointer;
    outline: none;
    padding: 9px 18px;
    transition: all 200ms ease;
  }

  .Dropdown-arrow {
    border-color: #999 transparent transparent;
    border-style: solid;
    border-width: 5px 5px 0;
    content: ' ';
    display: block;
    height: 0;
    margin-top: -ceil(2.5);
    position: absolute;
    right: 10px;
    top: 14px;
    width: 0;
  }

  .is-open .Dropdown-arrow {
    border-color: transparent transparent #999;
    border-width: 0 5px 5px;
  }

  .Dropdown-menu {
    box-sizing: border-box;
    margin-top: -1px;
    max-height: 300px;
    overflow-y: auto;
    position: absolute;
    top: 100%;
    width: 100%;
    z-index: 3;
    -webkit-overflow-scrolling: touch;
  }

  .Dropdown-menu .Dropdown-group > .Dropdown-title {
    padding: 8px 10px;
    color: rgba(51, 51, 51, 1);
    font-family: var(--fontRegular);
    text-transform: capitalize;
  }

  .Dropdown-option {
    box-sizing: border-box;
    background: ${props => props.theme.secondaryBackground};
    color: ${props => props.theme.primaryText};
    cursor: pointer;
    display: block;
    padding: 8px 18px;
    font-size: 14px;
  }

  .Dropdown-option:last-child {
    border-bottom-right-radius: 2px;
    border-bottom-left-radius: 2px;
    border-bottom: none;
  }

  .Dropdown-option:hover {
    color: ${props => props.theme.primaryTheme};
    svg {
      color: ${props => props.theme.primaryText};
    }
  }

  .Dropdown-option.is-selected {
    color: ${props => props.theme.primaryTheme};
    background: var(--main-bg-primary);
    &:hover {
      background: var(--main-bg-secondary);
    }
    svg {
      color: ${props => props.theme.primaryText};
    }
  }

  .Dropdown-noresults {
    box-sizing: border-box;
    color: #ccc;
    cursor: default;
    display: block;
    padding: 8px 10px;
  }
`;

export const HoverBox = styled.div`
  position: absolute;
  top: ${props => (props.type ? '-25px' : '25px')};
  margin-left: 5px;
  z-index: 3;

  @media (min-width: 1400px) {
    top: ${props => (props.type ? '-12px' : '25px')};
  }

  @media ${device.down.md} {
    margin-left: 0px;
    top: ${props => (props.type ? '-94px' : '-34px')};
    left: 0;
    width: 94vw;
  }
`;

export const WithdrawalHistoryWrapper = styled.div`
  flex-basis: 100%;
  width : 100%;
  margin-top: 40px;

  .withdrawal-history-heading{
    height: 40px;
    display : flex;
    align-items : center;
    font-family : var(--fontRegular);
    font-size: 14px;
    color: ${props => props.theme.primaryText};
    .refresh {
      margin-top: 3px;
      margin-left: 10px;
      font-family : var(--fontRegular);
      font-size: 10px;
      color: ${props => props.theme.secondaryText};
      display: flex;
      cursor: pointer;
      svg {
        margin: 0 4px;
      }
      &:hover {
        color: ${props => props.theme.primaryTheme};
        svg path {
          fill: ${props => props.theme.primaryTheme};
        }
      }
    }
  }
  .coin-selection-wrapper{
    display:flex;
    align-items: center;
    position: relative;
    gap: 5px;

    .Dropdown-control {
      color: var(--main-text-secondary);
      display: flex;
      align-items: center;
      width: 50px;
      height: 19px;
      font-size: 10px;
      padding: 0px 7px;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
    }
    .Dropdown-arrow-wrapper {
      position: relative;
      top: -2px;
    }

    .Dropdown-placeholder {
      margin-right: 3px;
    }

    .Dropdown-menu {
      border: none;
      border-radius: 2px;
      box-shadow: var(--dropdownBoxShadow);
      background-color: var(--main-bg-primary-alt);
      border-radius: var(--dropdownBorderRadius);
      margin-right: 2px;
      margin-top: 5px !important;
      width: 70px;
      .Dropdown-option {
        text-align: left;
        font-family: var(--fontRegular);
        font-size: 10px;
        color: ${props => props.theme.primaryText};
        > * {
          border: none !important;
        }
        &.is-selected {
          color: ${props => props.theme.primaryTheme};
          background-color: var(--main-bg-primary-alt);
          svg {
            color: ${props => props.theme.primaryText};
          }
        }
        border-radius: var(--dropdownBorderRadius);
        &:hover {
          color: var(--brand-text-primary);
          background-color: var(--dropdownItemHover);
        }
      }
    }
  }

  .coin-col-values {
    .coin-col-value {
      padding-left: 5px;
    }

    .coin-col-label {
      svg {
        margin-top: -5px;
      }
    }
  }

  .back-to-withdrawal {
    height: 38px;
    background-color: #212933;
    .col-24 {
      text-align: center;
    }
  }

  .completed-status-value-desktop {
    margin-left: 0px;

    .status-icon {
      svg {
        margin-top: -1px;
      }
    }

    .cancelled {
      width: 58px;
      height: 20px;
      font-family: var(--fontRegular);
      font-size: 12.1px;
      line-height: 1.67;
      letter-spacing: 0.6px;
      color: #d75750;
      padding-left: 0px;
    }

    .complete {
      width: 63px;
      height: 20px;
      font-family: var(--fontRegular);
      font-size: 12.1px;
      line-height: 1.67;
      letter-spacing: 0.6px;
      color: #55b987;
      padding-left: 0px;
    }

    .tooltip-text {
      margin-top: -4px;
      svg {
        margin-top: -2px;
      }
    }
  }

  .completed-status-value {
    margin-left: 0px;
    flex: 0 0 55%;

    .status {
      display: flex;
    }

    .status-icon {
      svg {
        margin-top: -9px;
      }
    }

    .cancelled {
      font-family: var(--fontRegular);
      font-size: 12.1px;
      letter-spacing: 0.6px;
      color: #d75750;
    }

    .complete {
      // width: 63px;
      height: 20px;
      font-family: var(--fontRegular);
      font-size: 12.1px;
      line-height: 1.67;
      letter-spacing: 0.6px;
      color: #55b987;
      // padding-left: 5px;
    }

    .tooltip-text {
      padding-left: 9px;
      margin-top: -4px;
    }
  }

  .completed-address-values {
    margin-left: 0px;
  }

  .header-row-completed-values {
    margin-left: 0px;
    .header-details {
      text-align: left;
      margin-left: -5px;
      .coin-info {
        .coin-icon-value {
          padding-left: 0px;
          svg {
            margin-top: -5px;
          }
        }
        .coin-symbol {
          padding-left: 5px;
        }
      }
      .tooltip-hover-info {
        padding-left: 4px;
      }
    }
    .coin-amount {
      text-align: right;

      .amount-label {
        width: 45px;
        height: 14px;
        opacity: 0.9;
        font-family: var(--fontRegular);
        font-size: 12.1px;
        line-height: 1.17;
      }

      .amount-value {
        padding-left: 5px;
        width: 68px;
        height: 14px;
        font-family: var(--fontRegular);
        font-size: 12.1px;
        line-height: 1.17;
        text-align: right;
        color: white;
      }
    }
  }
  .navigate-to-completed-withdrawl {
    height: 20px;
    font-family: var(--fontRegular);
    font-size: 14px;
    line-height: 1.43;
    color: ${props => props.theme.primaryTheme};
    .col-24 {
      text-align: center;
    }
  }
  .history {
    padding-top: 0;
    .addresSpan {
      position: relative;
      display: flex;
      .track-icon {
        margin-left: 12px;
      }
    }

    .box-section {
      min-width: 290px;
      min-height: 129px;
      margin: 4px 4px 15px 4px;
      padding: 14px;
      border-radius: 6px;
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
      background-color: #19222c;

      &:nth-child(even) {
        background-color: #17202c;
      }

      hr {
        border: none;
        border-bottom: 1px solid #303d4e;
        margin: 10px auto;
      }

      .row {
        padding: 0px 0px 5px 0px;
      }

      .price {
        font-family: var(--fontRegular);
        font-size: 12.1px;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: 0.6px;
        color: ${props => props.theme.primaryText};
      }
      .time {
        font-family: var(--fontRegular);
        font-size: 11px;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: 0.6px;
        color: ${props => props.theme.primaryText};
        text-align: right;
      }
    }

    .history-list-header {
      color: white;
      width: 100%;
      font-family: var(--fontRegular);
      font-size: 16px;
      line-height: 20px;
      line-height: 1.5;
      color: ${props => props.theme.primaryText};
      margin-bottom: 18px;
      margin-left: 0px;
    }

    .wallet-address-text {
      margin-left: 2px;
    }
    .header-row-pending-values {
      margin-left: -11px;
      margin-right: -10px;
      .amount-label {
        width: 45px;
        height: 14px;
        opacity: 0.9;
        font-family: var(--fontRegular);
        font-size: 12.1px;
        line-height: 1.17;
      }
      .amount-value {
        padding-left: 5px;
        width: 68px;
        height: 14px;
        font-family: var(--fontRegular);
        font-size: 12.1px;
        line-height: 1.17;
        text-align: right;
        color: white;
      }
    }
    .no-status-mobile {
      text-transform: capitalize;
      font-family: var(--fontRegular);
      font-size: 11.5px;
      line-height: 1.39;
      letter-spacing: 0.6px;
      .space-text {
        padding-left: 4px;
      }
    }
    .in-progress-status {
      & > div {
        display: flex;
        align-items: center;
      }
      text-transform: capitalize;
      padding: 0px !important;
      margin-left: -7px;
      padding: 0px;
      font-family: var(--fontRegular);
      font-size: 12.1px;
      line-height: 1.39;
      letter-spacing: 0.6px;
      color: #ff8d11;
      .space-text {
        padding-left: 4px;
      }
    }
    .await-confirmed-status {
      text-transform: capitalize;
      padding: 0px;
      font-family: var(--fontRegular);
      font-size: 11.5px;
      line-height: 1.39;
      letter-spacing: 0.6px;
      .space-text {
        padding-left: 2px;
      }
      .awaiting-processing-text {
        letter-spacing: 0.6px;
        color: #ef8b15;
        padding-left: 2px;
        font-family: var(--fontRegular);
      }
      .cancel {
        margin-left: 10px;
        color: ${props => props.theme.primaryTheme};
        font-family: var(--fontRegular);
      }
    }
    .email-pending-status {
      text-transform: capitalize;
      .is-disabled {
        cursor: not-allowed !important;
      }
      .state-info {
        text-align: left;
        .email-icon {
          svg {
            width: 13px;
            height: 11px;
          }
        }
        .state-text {
          padding-left: 0px;
          height: 20px;
          font-family: var(--fontRegular);
          font-size: 12.1px;
          line-height: 1.67;
          letter-spacing: 0.6px;
          color: #e7dc89;
        }
        .info-icon {
          padding-left: 0px;
        }
      }
      .resend-email-info {
        text-align: right;
        .resend-email-text {
          height: 20px;
          font-family: var(--fontRegular);
          font-size: 10px;
          line-height: 2;
          letter-spacing: 0.6px;
          color: ${props => props.theme.primaryTheme};
        }
        .resend-email-icon {
          svg {
            width: 18px;
            height: 18px;
            padding-right: 0px;
            margin-top: 3px;
          }
        }
      }
    }
    .pending-status {
      text-transform: capitalize;
      width: 153px;
      height: 32px;
      font-family: var(--fontRegular);
      font-size: 11.5px;
      line-height: 1.39;
      letter-spacing: 0.6px;
      color: #e7dc89;
      .resend-email {
        font-size: 9.5px;
        letter-spacing: 0.6px;
        color: ${props => props.theme.primaryTheme};
        cursor: pointer;
        padding-left: 17px;
      }
      .is-disabled {
        cursor: not-allowed !important;
      }
    }
    .awaiting-processing {
      // height: 32px;
      font-family: var(--fontRegular);
      font-size: 12.1px;
      line-height: 1.39;
      letter-spacing: 0.6px;
      color: #ef8b15;
      .cancel {
        color: ${props => props.theme.primaryTheme};
        cursor: pointer;
        padding-left: 10px;
      }
    }
    .in-progress {
      height: 20px;
      font-family: var(--fontRegular);
      font-size: 11.5px;
      line-height: 1.74;
      letter-spacing: 0.6px;
      color: #ff8d11;
      padding-right: 3px;
      display: flex !important;
      align-items: center;
      svg {
        margin-right: 3px;
      }
      span {
        padding-left: 3px;
      }
    }
    }

    .cancelled-status {
      font-family: var(--fontRegular);
      font-size: 12px;
      line-height: 1.5;
      color: ${props => props.theme.negative};
    }

    .completed-status {
      font-size: 12.1px;
      text-transform: capitalize;
    }
  }

  &::-webkit-scrollbar-track-piece {
    margin-top: 15px;
  }

  @media ${device.down.md} {
    padding: 0 0 20px 0;
    margin-top: 0;
  }

  .withdrawal-history-table {
    .rt-table {
      overflow: visible;
    }
    .rt-thead {
      .rt-th {
        overflow: visible;
      }
    }
  }

  .withdrawal-history-table-empty-state {
    padding-top: 50px;
    display: block;
    text-align: center;
    img {
      width: 90px;
      height: 90px;
    }
    .text {
      width: 176px;
      height: 15px;
      font-family: var(--fontRegular);
      font-size: 12.1px;
      text-align: center;
      color: ${props => props.theme.secondaryText};
    }
  }
`;

export const CancelButton = styled.button`
  width: 42px;
  height: 22px;
  border-radius: 1px;
  border: solid 0.8px ${props => props.theme.negative};
  color: ${props => props.theme.negative};
  cursor: pointer;

  &:hover {
    background-color: ${props => props.theme.negative};
    color: #fff;
  }
`;

export const KycVerifyModal = styled(Modal)`
  width: 440px !important;
  height: 320px !important;
  left: 40% !important;
  top: unset !important;
  bottom: 35% !important;
  padding: 40px !important;
  position: absolute;
  background: ${props => props.theme.primaryBackground} !important;
  .modal-body {
    font-family: var(--fontRegular);
    font-size: 14px;
    color: ${props => props.theme.primaryText};
    text-align: center;

    .text {
      margin-top: 16px;
    }

    .btns-container {
      display: flex;
      justify-content: space-between;
      margin-top: 60px;

      .get-verified,
      .cancel {
        font-family: var(--fontRegular);
        width: 150px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .get-verified {
        background: ${props => props.theme.primaryTheme};
        color: var(--primaryCtaText);
        &:hover {
          background: ${props => props.theme.primaryButtonHover};
        }
      }
      .cancel {
        border: 1px solid ${props => props.theme.secondaryText};
      }
    }
  }
  @media ${device.down.md} {
    width: 100% !important;
    height: 290px !important;
    left: 0% !important;
    bottom: 0% !important;
    padding: 20px !important;
    .modal-body {
      .text {
        margin-top: 10px;
      }
      span.cancel-icon {
        position: relative;
        left: 47%;
      }
      .btns-container {
        margin-top: 37px;
        .get-verified {
          width: 100%;
        }
      }
    }
  }
`;

export const MobileCancelButton = styled.button`
  background-color: transparent;
  border-radius: 2px;
  padding: 2px 6px 2px 6px;
  color: ${props => props.theme.negative};
  display: flex;
  justify-content: space-between;
  line-height: 15px;
  font-size: 11px;
  border: 1px solid ${props => props.theme.negative};
  cursor: pointer;

  .space-text {
    margin-right: 5px;
    svg {
      width: 10px;
    }
  }
`;

export const WithDrawalPageTable = styled(Table)`
  font-family: var(--fontRegular);
  margin-bottom: 30px;
  color: ${props => props.theme.secondaryText};

  &.ReactTable {
    border: none;
    .rt-thead {
      &.-header {
        box-shadow: none;
      }
      .rt-th {
        padding: 10px 18px;
        &:nth-of-type(4) {
          display: flex;
          justify-content: flex-end;
        }
        &:nth-of-type(5) {
          margin-left: 15px;
        }
      }
    }
  }

  .rt-tbody {
    .rt-td {
      padding: 10px 18px;
      font-size: 12.1px;
      color: ${props => props.theme.secondaryText};
      font-family: var(--fontRegular);
      display: flex;
      align-items: center;
      &.amount {
        justify-content: flex-end;
      }
      &.date {
        margin-left: 15px;
      }
      .copySpan {
        svg {
          width: 12px;
          height: 12px;
        }
      }
    }
  }

  &.ReactTable {
    .rt-thead {
      .rt-tr {
        text-align: left;
      }
    }

    .rt-tbody {
      .rt-tr-group {
        border-bottom: none;
      }
    }

    .rt-thead {
      font-size: 12.1px;
      font-family: var(--fontRegular);
      line-height: 1.22;
      box-shadow: none;
      border-bottom: 0.8px solid ${props => props.theme.separator};
    }

    .rt-tbody {
      .rt-tr-group {
        border-bottom: 0.8px solid ${props => props.theme.separator};
        .rt-tr {
          &.-even,
          &.-odd {
            .share-cell {
              svg {
                g {
                  fill: rgba(4, 13, 25, 0.25);
                }
              }
              text-align: center;
              cursor: pointer;
            }
          }
        }
      }

      .pagination-bottom {
        background: ${props => props.theme.primaryBackground};
        font-size: 12.1px;
        margin-top: 20px;

        @media ${device.down.sm} {
          margin-top: 20px;
        }

        .-pagination {
          box-shadow: none;
          border: none;
          padding: 0;

          .-pageInfo {
            margin: 2px 10px;

            input {
              padding: 3px 7px;
              background: ${props => props.theme.primaryBackground};
            }
          }

          .-previous,
          .-next {
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
  }
`;

export const MobileWithdrawalWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-top: 0px;
  font-family: var(--fontRegular) !important;

  &.disable {
    .dropdown-label {
      pointer-events: none;
    }
  }

  .free-tag {
    background: linear-gradient(
      135deg,
      ${props => props.theme.highlight} 0%,
      ${props => props.theme.highlight} 100%
    );
    border-radius: 2px;
    width: 22px;
    height: 11px;
    font-family: var(--fontRegular);
    font-size: 7px;
    color: ${props => props.theme.primaryBackground};
    padding: 2px 5px;
  }
  .forfeit-link {
    display: flex;
    justify-content: flex-end;
    color: ${props => props.theme.primaryTheme};
    font-size: 12.1px;
    font-family: var(--fontRegular);
    cursor: pointer;
    margin-top: 2px;
    position: relative;
    left: 4px;
    svg {
      margin-top: 2px;
    }
    @media ${device.down.md} {
      position: relative;
      left: 10px;
      font-family: var(--fontRegular);
      margin-top: 1px;
      svg {
        width: 17px;
        height: 13px;
        margin-top: 3px;
      }
    }
  }

  .hr {
    height: 1px;
    margin: 10px 0 10px 4px;
    border: solid 1px rgba(61, 79, 106, 0.4);
  }

  .withdrawal-bottom-container {
    position: fixed;
    bottom: 0;
    background: ${props => props.theme.secondaryBackground};
    width: 100%;
    left: 0;
    padding: 3px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0px -4px 8px rgba(20, 20, 20, 0.28);
    .amount-container {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
    }
    .withdrawal-fee {
      position: relative;
      top: 3px;
      .form-label {
        position: relative;
        top: 3px;
      }
    }
  }

  .max-withdrawable-amount-data {
    width: 100%;
    margin-top: 5px;
    @media ${device.down.md} {
      margin-top: 10px;
      &.trading-credits {
        margin-top: 10px;
      }
    }
  }

  .max-withdrawable-area {
    display: flex;
    justify-content: space-between;
    height: 100%;
    &.without-forfeit {
      margin-bottom: 10px;
    }
    &.after-forfeit {
      .amount {
        color: ${props => props.theme.primaryText};
        cursor: default;
        text-decoration: none;
        text-align: right;
      }
      .forfeit-link {
        position: relative;
        top: 0;
        left: 5px;
      }
    }

    .max-withdrawable-label {
      font-family: var(--fontRegular);
      font-size: 12.1px;
      color: ${props => props.theme.secondaryText};
      display: flex;
    }

    .amount {
      font-family: var(--fontRegular);
      font-size: 12.1px;
      cursor: pointer;
      text-decoration: underline;
      color: ${props => props.theme.primaryTheme};
    }
  }

  .history-view-button {
    font-family: var(--fontRegular);
    font-size: 14px;
    font-stretch: normal;
    font-style: normal;
    line-height: 40px;
    letter-spacing: 0.6px;
    text-align: center;
    color: ${props => props.theme.primaryTheme};
    border-top: solid 1px ${props => props.theme.separator};
    position: fixed;
    width: 100%;
    bottom: 0;
    height: 40px;
    background-color: ${props => props.theme.primaryBackground};
    left: 0;
  }

  .input-section {
    margin-bottom: 25px;
    position: relative;
    &.row {
      margin-left: 0;
      margin-right: 0;
    }
    .error {
      font-size: 11px;
      color: ${props => props.theme.negative};
      width: 100%;
    }
    .input-area {
      display: flex;
      align-items: center;
      background-color: var(--inputBackground);
      border-radius: var(--inputBorderRadius);
      font-family: var(--fontRegular);
      margin-top: 7px;

      .address-label {
        height: 25px;
        font-size: 14px;
        font-family: var(--fontRegular);
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: 0.6px;
        color: ${props => props.theme.primaryText};
        margin-left: 10px;
        border: 1px solid ${props => props.theme.separator};
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 3px 7px;
        max-width: 50px;
        display: inline-block;
        text-overflow: ellipsis;
        overflow: hidden;
        @media ${device.down.md} {
          margin-top: 0px;
        }
      }

      .input-box {
        font-size: 14px;
        color: ${props => props.theme.secondaryText};
        font-family: var(--fontRegular);
        text-align: left;
        width: 100%;
        text-overflow: ellipsis;
        position: relative;
        top: 0;
        padding-right: 80px;
      }
    }
  }

  .network-checkbox {
    background: ${props => props.theme.secondaryBackground};
    border-radius: 2px;
    height: 42px;
    display: flex;
    width: auto;
    flex-grow: 1;
    max-width: 140px;
    margin-top: 4px;
    cursor: pointer;
    &.active {
      border: 1px solid ${props => props.theme.primaryTheme};
    }
    .network {
      font-family: var(--fontRegular);
      font-size: 12.1px;
      color: ${props => props.theme.primaryText};
    }
  }

  .networks-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }

  .max-withdrawable-button {
    position: absolute;
    top: 34px;
    left: 10px;
    font-family: var(--fontRegular);
    font-size: 12.1px;
    color: ${props => props.theme.primaryTheme};
    border-radius: 4px;
    padding: 5px 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .input-label {
    font-family: var(--fontRegular);
    font-size: 12.1px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: 0.6px;
    color: ${props => props.theme.secondaryText};
    margin-bottom: 7px;
  }

  .input-box {
    height: 44px;
    padding: 10px 18px;
    text-align: left;
    font-family: var(--fontRegular);
    background-color: var(--main-bg-primary);
    border-radius: var(--inputBorderRadius);
    border: 1px solid var(--main-bg-secondary);
    &.max-input {
      padding: 11px 18px 11px 70px;
    }

    &:focus {
      border: 1px solid var(--brand-bg-primary);
    }
  }

  .input-box[name='memo'] {
    border: none;
  }

  .withdrawal-limit {
    font-size: 12.1px;
    color: ${props => props.theme.secondaryText};
    margin-bottom: 22px;
    .current-limit {
      color: ${props => props.theme.primaryText};
      font-family: var(--fontRegular);
    }
    .get-verified-link {
      font-size: 12.1px;
      margin-left: 0;
      margin-top: 8px;
    }
    .lifetime-limit {
      margin: 6px 0 8px;
    }
    svg {
      margin-top: 0;
    }
  }

  .currency {
    position: absolute;
    top: 36px;
    font-size: 14px;
    padding-left: 8px;
    border-left: 1px solid ${props => props.theme.primaryText};
    right: 18px;
    font-size: 12.1px;
    color: ${props => props.theme.secondaryText};
  }
  .max-withdrawable-popup {
    width: 100%;
    margin-top: 10px;
  }
`;

export const MobileHistoryCard = styled.div`
  width: 95vw;
  height: auto;
  padding: 10px 15px 20px 12px;
  border-radius: 6px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  font-family: var(--fontRegular);
  margin: 0 auto 10px;
  background: ${props => props.theme.secondaryBackground};

  .coin-status {
    justify-content: space-between;
  }

  .status-complete {
    border-radius: 2px;
    // background-color: rgba(85, 185, 135, 0.1);
    // color: #55b987;
    font-size: 12.1px;
    padding: 3px;
  }

  .card-label {
    opacity: 0.9;
    font-size: 12.1px;
  }

  .value {
    font-size: 12.1px;
    color: ${props => props.theme.primaryText};
    .copySpan svg {
      width: 16px;
    }
  }

  .coin {
    font-size: 14px;
    color: ${props => props.theme.primaryText};
    display: flex;
    align-items: center;

    svg {
      margin-right: 2px;
    }

    .asset-and-network {
      display: flex;
      align-items: center;
    }
    .network {
      background: ${props => props.theme.primaryBackground};
      font-family: var(--fontRegular);
      font-size: 10px;
      color: ${props => props.theme.primaryTheme};
      padding: 3px 5px;
      margin-left: 10px;
      border-radius: 2px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: -2px;
    }
  }

  .hr {
    height: 1px;
    margin: 10px 0 10px 4px;
    border: 1px solid rgba(61, 79, 106, 0.1);
  }

  .amount-and-date {
    display: flex;
    justify-content: space-between;
  }
  .date {
    letter-spacing: 0.6px;
    font-size: 11px;
  }

  .amount-and-date,
  .receieved,
  .transaction {
    margin-bottom: 12px;
  }

  .amount,
  .address {
    display: flex;
    flex-direction: column;
  }
  .track-icon {
    svg {
      width: 16px;
      height: 20px;
      margin-left: 15px;
    }
  }
`;

export const MobileHistoryOverlay = styled.div`
  position: relative;
  z-index: 7;
  top: 16px;
  margin: 0;
`;

export const ForFeitModalWrapper = styled.div`
  background: ${props => props.theme.primaryBackground};
  font-family: var(--fontRegular);
  max-width: ${props => (props.isMobile ? '100%' : '440px')};
  color: ${props => props.theme.primaryText};
  .heading {
    background-color: ${props => props.theme.primaryBackground};
    text-align: center;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${props => props.theme.secondaryText};
    border-bottom: 1px solid var(--divider-primary);
  }
  .body {
    padding: 0px 36px 36px 36px;
    .balances {
      .row {
        margin: 30px 0;
        justify-content: space-between;
        .label {
          font-size: 14px;
          color: ${props => props.theme.secondaryText};
        }
      }
    }
    .msg {
      font-size: 12.1px;
      // border-radius: 3px;
      background-color: rgba(25, 188, 237, 0.05);
      border: solid 0.6px rgba(25, 188, 237, 0.4);
      color: ${props => props.theme.primaryTheme};
      padding: 7px 14px;
      margin-bottom: 40px;
      .title {
        text-align: center;
        padding-bottom: 5px;
        font-family: var(--fontRegular);
      }
      .desc {
        text-align: center;
        line-height: 1.5;
      }
    }
    .buttons {
      justify-content: space-between;
      button {
        width: 142px !important;
        border-radius: 0px;
        font-family: var(--fontRegular);
      }
      .cancel {
        border: 1px solid ${props => props.theme.secondaryText};
        background: none;
        color: var(--main-text-secondary);
        &:hover {
          background: ${props => props.theme.primaryBackground} !important;
        }
      }
    }
  }
  @media ${device.up.md} {
    .close {
      display: none;
    }
  }
  @media ${device.down.md} {
    padding-bottom: 0px;
    .heading {
      height: 45px;
      font-size: 14px;
      border-bottom: 0.8px solid ${props => props.theme.separator};
      background: unset;
      .close {
        right: 20px;
        position: fixed;
      }
    }
    .body {
      padding: 0 20px;
      .balances .row {
        margin: 20px 0;
      }
      .buttons {
        margin-bottom: 20px;
        .submit {
          width: 100% !important;
          border-radius: 0;
        }
        .cancel {
          display: none;
        }
      }
    }
    .msg {
      margin-bottom: 20px;
      .title {
        line-height: 1.82;
      }
      .desc {
        font-size: 11px;
      }
    }
  }

  .forfiet-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 0px;
    padding-bottom: 0px;
  }
`;
